module.exports = __webpack_public_path__ + "static/media/sort-amount-down.b2bd0445.svg";